<div class="pop-bg">
</div>
<div class="pop-position">
  <div class="row col-md-12 p-0 grey header-popup-box">
    <span class="col-md-10 col-sm-10 p-0">
      <div class="heading-panel pl-10">
        <span class="text-sm text-ellipsis heading-txt flex ml-10">Project Code
        </span>
      </div>
    </span>
    <span class="pull-right text-right col-md-2 col-sm-2 pv-10 cursor" (click)="Close()">
      <i class="fa fa-times" aria-hidden="true"></i>
    </span>
  </div>
  <div class="col-md-12 p-0">
    <div class="row col-md-12 p-0 mt-10 border-b" style="margin-top:0.5rem !important">
      <div class="col-md-3">
        <label class="custom-control">
          <input type="checkbox" id="selectall" [(ngModel)]="SelectAll" (change)="SelectAllToggle($event)" />
          <label for="selectall">Select All Project Code</label>
        </label>
      </div>
      <div class="col-md-2 p-0">
        <button class="btn blue square-btn blue-hover btn-txt mb-9 btn-default" (click)="saveProjects()">Save</button>
      </div>
    </div>
    <div class="col-md-12 code-auto-scroll p-0">
      <div class="row col-md-12 p-0 mt-10">
        <div class="col-md-4 mt-10" *ngFor="let project of AllProjects;let k = index;">
          <label class="custom-control">

            <input type="checkbox" id="{{project.Id}}" [checked]="(project.Is_Selected)" (change)="checkSelect(k)" />
            <label for="{{project.Id}}">{{project.Project_Name}} </label>
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
